import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { AdminUser } from "./users.types";

export const adminUsersQueryOptions = queryOptions({
	queryKey: ["admin", "users"],
	queryFn: () => api.get<AdminUser[]>("/platform/admin/users"),
});
